PJQ.views.commitments.CommitmentManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitment-management'),
        subTemplates: {
            commitmentTotals: new PJQ.templating.Template(PJQ.constants.modules.COMMITMENTS, 'commitment-management-totals'),
            invoiceTotals: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management-totals')
        },
        commitmentId: null,
        changeOrderId: null,
        invoiceId: null,
        view: null
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
        'click .btn-settings': 'settings'
    },
    beforeFirstRender: function () {
        this.options.canViewCommitments = PJQ.app.session.project.hasPermission('commitments.canView');
        this.options.canViewChangeOrders = PJQ.app.session.project.hasPermission('commitmentChangeOrders.canView');
        this.options.canViewInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canView');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('commitments.isAdmin')
            && PJQ.app.session.project.hasPermission('commitmentChangeOrders.isAdmin')
            && PJQ.app.session.project.hasPermission('payableInvoices.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            commitments: this.commitments,
            changeOrders: this.changeOrders,
            invoices: this.invoices,
            canViewCommitments: this.options.canViewCommitments,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        this.commitmentsView = null;
        this.changeOrdersView = null;
        this.invoicesView = null;

        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.commitmentId > 0 && this.options.canViewCommitments) {
            this.activateTab('commitments');
        } else if (this.options.changeOrderId > 0 && this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.invoiceId > 0 && this.options.canViewInvoices) {
            this.activateTab('invoices');
        } else if (this.options.canViewCommitments) {
            this.activateTab('commitments');
        } else if (this.options.canViewChangeOrders) {
            this.activateTab('changeorders');
        } else if (this.options.canViewInvoices) {
            this.activateTab('invoices');
        }
    },
    renderStats: function () {
        let totals,
            $totals = this.$('.totals-outer');
        switch (this.activeView) {
            case 'changeorders':
                if (this.changeOrdersView == null || this.changeOrdersView.collection == null || !this.changeOrdersView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.changeOrdersView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.commitmentTotals, $totals, {
                    pending: totals[PJQ.constants.commitments.changeOrderStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.commitments.changeOrderStatusBuckets.PROJECTED.name],
                    committed: totals[PJQ.constants.commitments.changeOrderStatusBuckets.COMMITTED.name]
                });
                break;
            case 'invoices':
                if (this.invoicesView == null || this.invoicesView.collection == null || !this.invoicesView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.invoicesView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.invoiceTotals, $totals, {
                    draft: totals[PJQ.constants.invoicing.payableInvoiceStatus.DRAFT],
                    reviewing: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVIEWING],
                    approved: totals[PJQ.constants.invoicing.payableInvoiceStatus.APPROVED],
                    complete: totals[PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE],
                    revise: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVISE]
                });
                break;
            default:
                if (this.commitmentsView == null || this.commitmentsView.collection == null || !this.commitmentsView.collection.isFetched) {
                    $totals.empty();
                    return;
                }

                totals = this.commitmentsView.collection.getTotalAmountsByStatus();
                this.renderSubTemplate(false, this.options.subTemplates.commitmentTotals, $totals, {
                    pending: totals[PJQ.constants.commitments.commitmentStatusBuckets.PENDING.name],
                    projected: totals[PJQ.constants.commitments.commitmentStatusBuckets.PROJECTED.name],
                    committed: totals[PJQ.constants.commitments.commitmentStatusBuckets.COMMITTED.name]
                });
                break;
        }
    },
    activateTab: function (tab) {
        this.activeView = tab;
        switch (tab ? tab.toLowerCase() : null) {
            case 'changeorders':
                tab = 'CCO_List';
                this.renderChangeOrdersView();
                break;
            case 'invoices':
                tab = 'PI_List';
                this.renderInvoicesView();
                break;
            default:
                tab = 'C_List';
                this.renderCommitmentsView();
                break;
        }

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;

        this.renderStats();
    },
    tabActivated: function (e) {
        if(this.isActivating){
            return;
        }

        this.activeTab = $(e.target).attr('href');

        let vw;
        switch (this.activeTab) {
            case '#C_List':
                vw = 'commitments';
                break;
            case '#CCO_List':
                vw = 'changeorders';
                break;
            case '#PI_List':
                vw = 'invoices';
                break;
        }
        this.activateTab(vw);
    },
    renderCommitmentsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/commitments', {
            trigger: false
        });
        if (this.commitmentsView == null && this.options.canViewCommitments) {
            let fnRender = _.bind(function () {
                this.commitmentsView = new PJQ.views.commitments.CommitmentsList({
                    el: this.$('.commitments-pane'),
                    project: PJQ.app.session.project,
                    commitmentId: this.options.commitmentId,
                    collection: this.commitments,
                    afterRender: _.bind(this.renderStats, this),
                    onCommitmentSave: _.bind(function () {
                        this.renderStats();
                    }, this),
                    onCommitmentDelete: _.bind(function () {
                        this.renderStats();
                    }, this),
                    onChangeOrderAdd: _.bind(function (changeOrder) {
                        if (this.changeOrders != null) {
                            this.changeOrders.add(changeOrder);

                            if (this.changeOrdersView != null) {
                                this.changeOrdersView.render();
                            }
                        }
                        this.renderStats();
                    }, this),
                    onChangeOrderDelete: _.bind(function (changeOrderId) {
                        if (this.changeOrders) {
                            let changeOrder = this.changeOrders.get(changeOrderId);
                            this.changeOrders.remove(changeOrder);

                            if (this.changeOrdersView != null) {
                                this.changeOrdersView.render();
                            }
                            this.renderStats();
                        }
                    }, this),
                    onInvoiceAdd: _.bind(function (invoice) {
                        if (this.invoices != null) {
                            this.invoices.add(invoice);

                            if (this.invoicesView != null) {
                                this.invoicesView.render();
                            }
                        }
                    }, this)
                });
                this.options.commitmentId = null;
            }, this)

            if (this.commitments == null) {
                this.commitments = new PJQ.collections.commitments.Commitments(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.commitments.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChangeOrdersView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/commitments/changeorders', {
            trigger: false
        });
        if (this.changeOrdersView == null && this.options.canViewChangeOrders) {
            let fnRender = _.bind(function () {
                this.changeOrdersView = new PJQ.views.commitments.ChangeOrdersList({
                    el: this.$('.change-orders-pane'),
                    project: PJQ.app.session.project,
                    changeOrderId: this.options.changeOrderId,
                    collection: this.changeOrders,
                    afterRender: _.bind(this.renderStats, this),
                });
                this.options.changeOrderId = null;
            }, this)

            if (this.changeOrders == null) {
                this.changeOrders = new PJQ.collections.commitments.ChangeOrders(null, {
                    projectId: this.options.project.get('projectId')
                });
                this.changeOrders.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/commitments/invoices', {
            trigger: false
        });
        if (this.invoicesView == null && this.options.canViewInvoices) {
            let fnRender = _.bind(function () {
                this.invoicesView = new PJQ.views.invoicing.PayableInvoicesList({
                    el: this.$('.invoices-pane'),
                    project: PJQ.app.session.project,
                    invoiceId: this.options.invoiceId,
                    inviteResponse: this.options.inviteResponse,
                    collection: this.invoices,
                    afterRender: _.bind(this.renderStats, this),
                    onDelete: _.bind(function (invoice) {
                        this.invoices.remove(invoice);
                    }, this)
                });
                this.options.invoiceId = null;
            }, this)

            if (this.invoices == null) {
                this.invoices = new PJQ.collections.invoicing.PayableInvoices(null, {
                    project: this.options.project
                });
                this.invoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        }
    },
    getActiveTab: function () {
        return this.$('.nav-item>.nav-link.active').attr('href');
    },
    settings: function () {
        switch (this.getActiveTab()) {
            case '#C_List':
                if (this.commitmentsView != null) {
                    this.commitmentsView.editSettings();
                }
                break;
            case '#CCO_List':
                if (this.changeOrdersView != null) {
                    this.changeOrdersView.editSettings();
                }
                break;
            case '#PI_List':
                if (this.invoicesView != null) {
                    this.invoicesView.editSettings();
                }
                break;
        }
    },
    updateTotalsCount: function () {
        let $commitmentSpan = this.$('.commitments-total'),
            $changeOrdersSpan = this.$('.change-orders-total'),
            $invoicesSpan = this.$('.invoices-total');
        $commitmentSpan.text(_.size(this.commitments.models));
        $changeOrdersSpan.text(_.size(this.changeOrders.models));
        $invoicesSpan.text(_.size(this.invoices.models));
    }
});